import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspSlotDeliveryService {

  constructor(
     private http: HttpClient,
  ) { }
  getSlotData(partKeys){
      let paramData ={
        partKeys:partKeys,
        garageKey:localStorage.getItem("garageKey"),
        source:"web",
      }
      // console.log(paramData);
      // console.log('-----get slot-----------');  
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` +'/bookingslots/get',paramData);
    }
}
